<template>
    <div id="statscoreHolder">
        <div :id="'sp_' + eventObject.fixtureId"></div>
    </div>
</template>

<script>
    import { HubConnection } from "@aspnet/signalr";
    import * as CONFIG from "../config";

    export default {
        data() {
            return {
                fixtureId: this.eventObject.fixtureId,
                statscoreIsMapped: false,
                statscoreEventID: 0,
                firstLoad: true
            }
        },
        name: 'Statscore',
        components: {
        },
        props: {
            eventObject: Object,
            isMobile: Boolean,
            sport: String,
            connection: HubConnection,
        },
        methods: {
        },

        watch: {
            eventObject: {
                handler(newVal, old) {
                    if (old.fixtureId !== newVal.fixtureId) {
                        document.getElementById('statscoreHolder').innerHTML = "";
                        if (CONFIG.STATSCORE_WIDGET) {
                            const configurationId = CONFIG.STATSCORE_CONFIG_ID;
                            if (newVal.statscoreIsMapped) {
                                if (!document.getElementById('sp_' + newVal.fixtureId)) {
                                    var element = document.createElement('div');
                                    element.id = 'sp_' + newVal.fixtureId;
                                    document.getElementById('statscoreHolder').appendChild(element);
                                }
                                else {
                                    element = document.getElementById('sp_' + this.eventObject.fixtureId);
                                }
                                if (this.isMobile) {
                                    document.getElementById('sp_' + newVal.fixtureId).innerHTML = "";
                                    const inputData = 
                                    {
                                        eventId: 'm:' + newVal.statscoreEventID,
                                        lang: 'en',
                                        timezone: -120
                                    };
                                    const options = {};
                                    const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);

                                } else {
                                    const inputData =
                                    { 
                                        eventId: 'm:' + newVal.statscoreEventID,
                                        lang: 'en',       
                                        timezone: -120
                                    };
                                    const options = {};
                                    const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                                }
                            }
                        }
                    }
                },
                deep: true
            }
        },
        mounted() {
            if (!this.firstLoad && this.eventObject) {
               document.getElementById('sp_' + this.eventObject.fixtureId).innerHTML = "";
               // check for img stream event
            }
            if (this.firstLoad && !this.isMobile) {

                if (CONFIG.STATSCORE_WIDGET) {
                    if (this.eventObject.statscoreIsMapped) {
                        this.firstLoad = false;
                        
                        if (!document.getElementById('sp_' + this.eventObject.fixtureId)) {
                            var element = document.createElement('div');
                            element.id = 'sp_' + this.eventObject.fixtureId;
                            document.getElementById('statscoreHolder').appendChild(element);
                        }
                        else {
                            element = document.getElementById('sp_' + this.eventObject.fixtureId);
                        }
                        const configurationId = CONFIG.STATSCORE_CONFIG_ID;
                        const inputData =
                        { 
                            eventId: 'm:' + this.eventObject.statscoreEventID,
                            lang: 'en',
                            timezone: -120
                        };
                        const options = {};
                        const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);

                    }
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
